export default __webpack_public_path__ + "8aae7b979b04407f71a41c0ccfec9fe5.svg";